import React from "react";
import Button from "@/components/ui/Button";

interface Props {
    open: boolean;
    title: string;
    description?: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    variant?: "default" | "destructive";
    busy?: boolean;
}

const ConfirmarDialog: React.FC<Props> = ({
    open,
    title,
    description,
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    onConfirm,
    onCancel,
    variant = "default",
    busy = false,
}) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center">
            <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
            <div className="relative z-[71] w-full max-w-md rounded-2xl border bg-white p-5 shadow-xl">
                <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                {!!description && <div className="mt-2 text-sm text-gray-700">{description}</div>}

                <div className="mt-5 flex items-center justify-end gap-2">
                    <Button variant="outline" onClick={onCancel} disabled={busy}>
                        {cancelText}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        className={variant === "destructive" ? "bg-red-600 hover:bg-red-700 text-white" : ""}
                        disabled={busy}
                    >
                        {busy ? "Procesando…" : confirmText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmarDialog;
